// V71.32 — Dashboard "Sektör Haberleri" kartı + Haberler sayfasıyla ortak yardımcılar
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { newsAPI } from '../services/api';
import '../pages/Haberler.css';

export const KAYNAK_RENK = {
  turizmguncel: '#0284c7', turizmgunlugu: '#d97706', turizmajansi: '#dc2626', turizmpress: '#059669', airporthaber: '#4f46e5',
};
export const haberZaman = (s) => (s ? new Date(s.replace(' ', 'T') + 'Z') : null);
export const zamanOnce = (s) => {
  const d = haberZaman(s);
  if (!d) return '';
  const dk = Math.max(0, Math.round((Date.now() - d.getTime()) / 60000));
  if (dk < 1) return 'şimdi';
  if (dk < 60) return `${dk} dk`;
  if (dk < 24 * 60) return `${Math.floor(dk / 60)} sa`;
  return d.toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit' });
};

// Görsel yüklenemezse kaynak renginde baş harf kutusu
export const HaberGorsel = ({ h, ad, className }) => {
  const [hata, setHata] = useState(false);
  if (!h.gorsel || hata) {
    return (
      <span className={`${className} hb-ph`} style={{ '--hb-c': KAYNAK_RENK[h.kaynak] || '#475569' }} aria-hidden="true">
        {(ad || h.kaynak).split(' ').map(w => w[0]).join('').slice(0, 2)}
      </span>
    );
  }
  return <img className={className} src={h.gorsel} alt="" loading="lazy" referrerPolicy="no-referrer" onError={() => setHata(true)} />;
};

// V71.33.1 — habere tıklayınca önizleme penceresi; Ctrl/⌘/orta tık doğrudan kaynağı yeni sekmede açar
export const haberTikla = (h, ac) => (e) => {
  if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
  e.preventDefault();
  ac(h);
};

const ayniBas = (a, b) => !!a && !!b && a.slice(0, 50) === b.slice(0, 50);

export const HaberModal = ({ h, ad, onClose }) => {
  const [o, setO] = useState(null);
  const gitRef = useRef(null);
  useEffect(() => {
    let iptal = false;
    setO(null);
    newsAPI.icerik(h.id).then(r => { if (!iptal) setO(r.data); }).catch(() => { if (!iptal) setO({ p: [], devami: true, hata: 'Önizleme alınamadı' }); });
    return () => { iptal = true; };
  }, [h.id]);
  useEffect(() => {
    gitRef.current?.focus();
    const esc = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', esc);
    return () => document.removeEventListener('keydown', esc);
  }, [onClose]);

  const d = haberZaman(h.yayin_at);
  const p = o?.p || [];
  const spot = h.ozet && !ayniBas(p[0], h.ozet) ? h.ozet : null;
  return createPortal(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-lg hb-modal" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="hb-modal-baslik">
        <button type="button" className="hb-modal-x" onClick={onClose} aria-label="Kapat">×</button>
        {h.gorsel && <HaberGorsel h={h} ad={ad} className="hb-modal-img" />}
        <div className="hb-modal-body">
          <span className="hb-meta hb-modal-meta">
            <span className="hb-src" style={{ '--hb-c': KAYNAK_RENK[h.kaynak] }}>{ad || h.kaynak}</span>
            {h.kategori && <span className="hb-kat">{h.kategori}</span>}
            {d && <span className="hb-time">{d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long', year: 'numeric' })} · {d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' })}</span>}
          </span>
          <h2 id="hb-modal-baslik" className="hb-modal-title">{h.baslik}</h2>
          {spot && <p className="hb-modal-spot">{spot}</p>}
          {!o ? (
            <div className="hb-modal-skel" aria-label="Yükleniyor"><i /><i /><i /><i /></div>
          ) : (
            <div className={`hb-modal-text${o.devami ? ' devami' : ''}`}>
              {p.map((t, i) => <p key={i}>{t}</p>)}
              {!p.length && !spot && <p>{o.hata || 'Bu haberin önizlemesi yok.'}</p>}
            </div>
          )}
          {o?.devami && <p className="hb-modal-note">Haberin devamı {ad || 'kaynak'} sitesinde.</p>}
        </div>
        <div className="hb-modal-foot">
          <button type="button" className="btn btn-secondary" onClick={onClose}>Kapat</button>
          <a ref={gitRef} className="btn btn-primary" href={h.url} target="_blank" rel="noopener noreferrer">Habere git ↗</a>
        </div>
      </div>
    </div>,
    document.body,
  );
};

const HaberMini = ({ limit = 12 }) => {
  const navigate = useNavigate();
  const [veri, setVeri] = useState(null);
  const [secili, setSecili] = useState(null);
  const kapat = useCallback(() => setSecili(null), []);

  useEffect(() => {
    let iptal = false;
    const yukle = () => newsAPI.list({ limit }).then(r => { if (!iptal) setVeri(r.data); }).catch(() => { if (!iptal) setVeri(v => v || { data: [], kaynaklar: [] }); });
    yukle();
    const t = setInterval(yukle, 10 * 60 * 1000);
    return () => { iptal = true; clearInterval(t); };
  }, [limit]);

  const ad = Object.fromEntries((veri?.kaynaklar || []).map(k => [k.kod, k.ad]));
  return (
    <div className="p-card">
      <div className="p-card-header">
        <h3>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--fg-brand)" strokeWidth="2"><path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-2 2zm0 0a2 2 0 0 1-2-2v-9c0-1.1.9-2 2-2h2"/><path d="M18 14h-8"/><path d="M15 18h-5"/><path d="M10 6h8v4h-8z"/></svg>
          Sektör Haberleri
        </h3>
        <button type="button" className="hb-mini-all" onClick={() => navigate('/haberler')}>Tümü →</button>
      </div>
      <div className="p-card-body">
        {!veri ? <div className="hb-mini-empty">Yükleniyor…</div>
          : veri.data.length === 0 ? <div className="hb-mini-empty">Henüz haber yok</div>
          : (
            <ul className="hb-mini">
              {veri.data.map(h => (
                <li key={h.id}>
                  <a href={h.url} target="_blank" rel="noopener noreferrer" onClick={haberTikla(h, setSecili)}>
                    <HaberGorsel h={h} ad={ad[h.kaynak]} className="hb-mini-img" />
                    <span className="hb-mini-txt">
                      <b>{h.baslik}</b>
                      <small><i style={{ background: KAYNAK_RENK[h.kaynak] }} />{ad[h.kaynak] || h.kaynak} · {zamanOnce(h.yayin_at)}</small>
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          )}
      </div>
      {secili && <HaberModal h={secili} ad={ad[secili.kaynak]} onClose={kapat} />}
    </div>
  );
};

export default HaberMini;
